import CloseButton from 'components/DesignSystems/buttons/CloseButton';
import { ReactNode } from 'react';

interface WizardButtonWrapperProps {
  onModalClose: () => void;
  children?: ReactNode;
}

export default function WizardButtonWrapper({
  onModalClose,
  children,
}: WizardButtonWrapperProps) {
  return (
    <div className="position-absolute bottom-0 p-3">
      <div className="d-flex flex-row justify-content-between align-items-center">
        <CloseButton onClose={onModalClose} />
        {children}
      </div>
    </div>
  );
}
